import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type IEarlyAccess } from '@/app/shared/types/earlyAccess';

const initialState = null as IEarlyAccess | null;

export const { reducer: earlyAccessReducer, actions: earlyAccessActions } = createSlice({
  name: 'earlyAccess',
  initialState,
  reducers: {
    setEarlyAccessData: (_state, action: PayloadAction<IEarlyAccess>) => action.payload,
  },
});
